import { dataAtom, dataComposer } from "@frend-digital/centra-legacy";

import { baseAtomics } from "@/lib/centra/atomicSetup";
import { getDisplayPricesWithSale } from "../../../../../../../packages/centra/src/formatting/atomics/priceAtomics";
import type { CentraProduct } from "../../atomicSetup";
import {
  getAvailability,
  getCategories,
  getComingSoon,
  getDisplayItemId,
  getGender,
  getLabels,
  getSoldOut,
  getVariants,
} from "../../localAtomics";
import getProductCore from "./getCore";
import getProductDescription from "./getDescription";
import getProductGallery from "./getGallery";

const { getProduct, getSku, getProductBreadcrumbs, getName, getVariantName } =
  baseAtomics;

const formatProductCard = (product: CentraProduct) => {
  const name = dataAtom(getName, 2)(product);
  const variantName = dataAtom(getVariantName, 2)(product);
  const core = getProductCore(product);
  const id = dataAtom(getProduct, 2)(product);
  const gallery = getProductGallery(product);
  const description = getProductDescription(product);
  const comingSoon = dataAtom(getComingSoon, 2)(product);
  const soldOut = dataAtom(getSoldOut, 2)(product);
  const sku = dataAtom(getSku, 2)(product);
  const breadcrumbs = dataAtom(getProductBreadcrumbs, 2)(product);
  const labels = dataAtom(getLabels, 2)(product);
  const variants = dataAtom(getVariants, 2)(product);
  const availability = dataAtom(getAvailability, 2)(product);
  const gender = dataAtom(getGender, 2)(product);
  const prices = dataAtom(getDisplayPricesWithSale, 2)(product);
  const displayItemId = dataAtom(getDisplayItemId, 2)(product);
  const categories = dataAtom(getCategories, 2)(product);

  const productCard = dataComposer({
    name,
    variantName,
    core,
    gallery,
    soldOut,
    comingSoon,
    description,
    id,
    breadcrumbs,
    variants,
    sku,
    labels,
    availability,
    gender,
    prices,
    displayItemId,
    categories,
  });
  return productCard.data;
};

// export const getProductCardData = (product: CentraProduct) =>
//   formatProductCard(product)["data"];

export default formatProductCard;

export type ProductCard = ReturnType<typeof formatProductCard>;
